import React, { useEffect, useState, useRef } from "react";
import InputMask from "react-input-mask";
import {
  Container,
  Label,
  ButtonGroup,
  Card,
  CardBody,
  Row,
  Col,
  Input,
  Button,
  Form,
} from "reactstrap";
import { useHistory, useParams } from "react-router-dom";
import { Helmet } from "react-helmet";
import Select from "react-select";
import { toast } from "react-toastify";
import ru from "date-fns/locale/ru";
import DatePicker, { registerLocale } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { CornerRightDown as CornerRightDownIcon } from "react-feather";
import classNames from "classnames";

import { brandsSuggestion, providersSuggestion, searchPrice2 } from "services/api";
import {
  createOrderToProvider,
  getOrderToProviderExcel,
  getOrderToProviderOne,
  getOrderToProviderStatuses,
  orderToProviderFileUpload,
  orderToProviderSelectionProducts,
  orderToProviderUploadDocument,
  setOrderToProviderStatus,
  updateOrderToProvider,
} from "services/apiSupply";

import { MySpinner } from "components/MySpinner";
import { dateFormat } from "utils/format";
import { HeaderPage } from "components/HeaderPage";
import { validHandler } from "utils/validation";
import { OrdersToProviderProductTable } from "features/OrdersToProvider/OrdersToProviderProductTable";
import { OrdersToProviderProductTableNew } from "features/OrdersToProvider/OrdersToProviderProductTableNew";
import { AddProductModal } from "features/OrdersToProvider/AddProductModal";
import { StatusOrderToProvider } from "components/StatusOrderToProvider";
import { ABC } from "pages/nomenclature";
import { SelectSearch } from "components/SelectSearch";
import { filterNotOurProvider } from "pages/dashboard";
import { useUser } from "features/Users/UserContext";

import "./orderToProviderOne.scss";

registerLocale("ru", ru);

export const VALID = ["provider"];

export const TYPES = [
  { value: "express", label: "Экспресс" },
  { value: "stock", label: "Складской" },
  { value: "invoice", label: "Инвойс" },
];
export const STOCK_MONTHS = [
  { value: 1, label: "1" },
  { value: 2, label: "2" },
  { value: 3, label: "3" },
  { value: 4, label: "4" },
  { value: 5, label: "5" },
  { value: 6, label: "6" },
]
const removeDuplicatesByProviderName = (array) => {
  const seen = new Set();
  return array.filter(item => {
    if (seen.has(item.providerName)) {
      return false;
    }
    seen.add(item.providerName);
    return true;
  });
}

export const sortResultByCost = (items) => {
  return items.sort(function (a, b) {
    if (a.cost && b.cost) {
      if (parseInt(a.cost * 100) > parseInt(b.cost * 100)) {
        return 1;
      }
      if (parseInt(a.cost * 100) < parseInt(b.cost * 100)) {
        return -1;
      }
    }
    return 0;
  });
};

const productsMap = (data, article, brand, searchData) => {

  console.log(data);

  const sortedSearchResult = sortResultByCost(filterNotOurProvider(searchData[brand][article]?.offer) || []);

  const index = data.findIndex(item =>
    item.article === article &&
    item.brand === brand
  );

  console.log(index);

  console.log(sortedSearchResult);

  const newArray = [...data];

  if (
    index > -1 && sortedSearchResult.length > 0
    && (parseInt(newArray[index].price * 100) > parseInt(sortedSearchResult[0].cost * 100) || !newArray[index].price)
  ) {
    newArray[index].price = sortedSearchResult[0].cost;
    newArray[index].summ = newArray[index].count * sortedSearchResult[0].cost;
    newArray[index].providerName = sortedSearchResult[0].providerName;
    newArray[index].providerId = sortedSearchResult[0].providerId;
    newArray[index].offer = removeDuplicatesByProviderName(newArray[index].offer ? [...newArray[index].offer, ...sortedSearchResult] : sortedSearchResult);
    newArray[index].priceDifference = newArray[index].costPrice
      ? Math.round((newArray[index].price - newArray[index].costPrice) / newArray[index].costPrice * 100)
      : 0;


  }

  return newArray;
}

const priceMap = (data, row, offer) => {
  const index = data.findIndex(item => item.id === row.id);

  const newArray = [...data];

  if (index > -1) {
    newArray[index].price = offer.cost;
    newArray[index].count = parseInt(offer.exist);
    newArray[index].summ = newArray[index].count * offer.cost;
    newArray[index].providerName = offer.providerName;
    newArray[index].providerId = offer.providerId;
  }

  return newArray;
}

export const OrderToProviderOnePage = () => {
  const history = useHistory();
  const { id } = useParams();
  const [isNew, setIsNew] = useState(false);
  const [loading, setLoading] = useState(false);
  const [comment, setComment] = useState("");
  const [status, setStatus] = useState({});
  const [products, setProducts] = useState([]);
  const [filteredProducts, setFilteredProducts] = useState([]);
  const [date, setDate] = useState("");
  const [dateArrival, setDateArrival] = useState("");
  const [createdAt, setCreatedAt] = useState("");
  const [docNum, setDocNum] = useState("");
  const [number, setNumber] = useState("");
  const [provider, setProvider] = useState(null);
  const [providers, setProviders] = useState([]);
  const [providerFilter, setProviderFilter] = useState(null);
  const [suggestions, setSuggestions] = useState([]);
  const [admin, setAdmin] = useState({});
  const [type, setType] = useState("");
  const [docLink, setDocLink] = useState("");
  const [errors, setErrors] = useState([]);
  const [needValid, setNeedValid] = useState(false);
  const [file, setFile] = useState(null);
  const inputFile = useRef(null);
  const inputDocumentFile = useRef(null);
  const [documentFile, setDocumentFile] = useState(null);
  const [openModal, setOpenModal] = useState(false);
  const [statuses, setStatuses] = useState([]);

  const { user } = useUser();

  const [search, setSearch] = useState("");
  const [searchLoading, setSearchLoading] = useState(false);

  const [filterAbc, setFilterAbc] = useState([]);
  const [stockMonths, setStockMonths] = useState(null);
  const [brand, setBrand] = useState(null);
  const [filterStatus, setFilterStatus] = useState([]);
  const [selected, setSelected] = useState([]);

  const providerMap = (res) =>
    res.map((item) => {
      return { value: item.id, label: item.name };
    });

  useEffect(() => {
    if (search.length < 3) {
      setSuggestions([]);
      return;
    }
    setSearchLoading(true);
    providersSuggestion(search)
      .then((res) => setSuggestions(providerMap(res)))
      .finally(() => setSearchLoading(false));
  }, [search]);

  const getAndSetOrderToProvider = () => {
    if (!id) {
      setIsNew(true);
      return;
    }
    setLoading(true);
    getOrderToProviderOne(id)
      .then((res) => {
        setDate(new Date(res.date));
        setCreatedAt(dateFormat(res.date));
        setNumber(res.number);
        setProvider({
          label: res.provider?.name,
          value: res.provider?.id,
        });
        setProducts(res.products || []);
        setComment(res.comment || "");
        setAdmin(res.admin);
        setStatus(res.status);
        setType(res.type);
        setDocLink(res.docLink);
        setDocNum(res.docNum);
        setDateArrival(res.dateArrival && new Date(res.dateArrival));
      })
      .catch((e) => {
        toast.error(e.response?.data?.message);
      })
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    getAndSetOrderToProvider();
    getOrderToProviderStatuses()
      .then(setStatuses)
      .catch((e) => {
        toast.error(e.response?.data?.message);
      });

    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const dateValidate = (val) => {
    const dateNow = new Date();
    if (val.getTime() > dateNow.getTime()) {
      toast.error("Дата не может быть больше сегодняшней");
      return;
    }
    setDate(val);
  };

  const dateArrivalValidate = (val) => {
    const dateNow = new Date();
    if (val.getTime() < dateNow.getTime()) {
      toast.error("Дата не может быть меньше сегодняшней");
      return;
    }
    setDateArrival(val);
  }

  const updateHandler = () => {
    if (!id) return;

    setLoading(true);
    updateOrderToProvider({
      id,
      provider: provider.value,
      comment,
      type,
      date: dateFormat(date),
      docNum,
      dateArrival: dateFormat(dateArrival)
    })
      .then((res) => {
        setDate(new Date(res.date));
        setCreatedAt(dateFormat(res.date));
        setNumber(res.number);
        setProvider({
          label: res.provider?.name,
          value: res.provider?.id,
        });
        setProducts(res.products);
        setComment(res.comment || "");
        setStatus(res.status);
        setType(res.type);
        setDocLink(res.docLink);
        setDateArrival(res.dateArrival && new Date(res.dateArrival));
        toast.success("Изменения успешно сохранены");
      })
      .catch((e) => {
        toast.error(e.response?.data?.message || "Ошибка при обновлении");
      })
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    const { errors } = validHandler(
      {
        provider: provider?.value,
      },
      VALID
    );
    setErrors(errors);
    // eslint-disable-next-line
  }, [provider]);

  const haveNullPrice = () => {
    const products = selected.length > 0
      ? filteredProducts.filter(v => selected.find(s => v.id === s))
      : filteredProducts;



    if (products.filter(v => !v.price).length) return true;
    return false;
  }

  const createHandler = () => {
    setNeedValid(true);

    const { valid, errors } = validHandler(
      {
        provider: provider?.value,
      },
      VALID
    );

    if (haveNullPrice()) {
      toast.error("Не должно быть позиций с нулевой ценой");
      return;
    }

    setErrors(errors);

    if (!valid) return;

    setLoading(true);
    createOrderToProvider({
      provider: provider?.value,
      comment,
      products: selected.length > 0 ? filteredProducts.filter(v => selected.find(s => v.id === s)) : filteredProducts,
      type,
      date: dateFormat(date),
      docNum,
      dateArrival: dateArrival && dateFormat(dateArrival)
    })
      .then((res) => {
        history.push(res.id);
        toast.success("Заказ поставщику успешно создан");
      })
      .catch((e) => {
        toast.error(e.response?.data?.message);
      })
      .finally(() => setLoading(false));
  };

  const renderTitle = () => {
    if (isNew) {
      return `Новый заказ поставщику`;
    }

    return `Заказ поставщику № ${number || ""} от ${provider?.label || ""}`;
  };

  const importHandler = (val) => {
    if (inputFile) {
      inputFile.current.click();
    }
  };

  useEffect(() => {
    if (!file) return;
    setLoading(true);
    const formData = new FormData();
    formData.append("file", file);
    orderToProviderFileUpload(formData)
      .then((res) => {
        setProducts(res);
      })
      .finally(() => {
        setLoading(false);
        inputFile.current.value = "";
      });

    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [file]);

  const statusHandler = (status) => {

    if (!dateArrival) {
      toast.success("Необходимо выбрать дату поставки");
      return;
    }

    if (haveNullPrice()) {
      toast.error("Не должно быть позиций с нулевой ценой");
      return;
    }

    setLoading(true);
    setOrderToProviderStatus({
      id,
      statusId: status?.id,
    })
      .then((res) => {
        setStatus(res.status);
        toast.success("Статус успешно изменен");
      })
      .catch((e) => {
        toast.error(e.response?.data?.message);
      })
      .finally(() => setLoading(false));
  };

  const searchPriceByProvider = (provider, article, brand, callback) => {
    searchPrice2({ article: article.replace("/", ""), brand, provider, adminId: user?.id })
      .then((res) => {



        setProducts(prev => productsMap(prev, article, brand, res.data));

        if (callback) {
          callback();
        }
      })
      .catch(e => {
        if (e.response?.status) {
          //toast.error(`Ошибка 500 ${provider}`);
        }
      })
      .finally(() => {
        // setProgress(prev => (prev + 1));
      });
  }

  useEffect(() => {
    console.log(products);
    setProviders(productProviderMap(products));
  }, [products]);

  const productProviderMap = (array) => {
    const seen = new Set();
    return array.filter(item => {
      if (seen.has(item.providerId) || !item.providerId) {
        return false;
      }
      seen.add(item.providerId);
      return true;
    }).map(product => ({
      label: product.providerName,
      value: product.providerId,
    }));
  }

  const searchProviders = (article, brand) => {
    searchPriceByProvider("", article, brand, function () {
      // PROVIDERS.forEach((provider, i) => {
      //   searchPriceByProvider(provider, article, brand);
      // });
    });
  };

  const selectHandler = () => {
    setLoading(true);
    orderToProviderSelectionProducts({
      abc: filterAbc.map(val => val.value),
      status: filterStatus.map(val => val.value),
      minStockNotEmpty: true,
      stockMonths: stockMonths?.value,
      brand: brand?.value
    })
      .then((res) => {
        setProducts(res);
        toast.success("Товары успешно загружены");
      })
      .catch((e) => {
        toast.error(e.response?.data?.message);
      })
      .finally(() => setLoading(false));
  }

  const filterHandler = () => {
    setFilteredProducts(prev => prev.filter(v => v.providerId === providerFilter?.value));
  }

  const setPrice = (row, offer) => {
    setProducts(prev => priceMap(prev, row, offer));
  }

  const searchHandler = () => {
    for (const item of products) {
      searchProviders(item.article, item.brand);
    }
  }

  useEffect(() => {
    if (!products) return;

    setFilteredProducts(() => {
      if (!providerFilter) {
        return products;
      }

      return products.filter(v => v.providerId === providerFilter?.value);
    });

  }, [products, providerFilter]);

  useEffect(() => {
    if (!documentFile) return;
    setLoading(true);
    const formData = new FormData();
    formData.append("file", documentFile);
    formData.append("id", id || null);
    orderToProviderUploadDocument(formData)
      .then((res) => {
        setDocLink(res.docLink);
        toast.success("Файл успешно загружен");
      })
      .finally(() => {
        setLoading(false);
        inputDocumentFile.current.value = "";
      });

    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [documentFile]);

  const importDocumentHandler = () => {
    if (inputDocumentFile) {
      inputDocumentFile.current.click();
    }
  };

  const exportHandler = () => {
    if (!number) return;
    setLoading(true);
    getOrderToProviderExcel({
      id
    })
      .then((res) => {
        const url = window.URL.createObjectURL(new Blob([res]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute(
          "download",
          `Заказ поставщику № ${number} от ${provider?.label}.xlsx`
        );
        document.body.appendChild(link);
        link.click();
      })
      .finally(() => {
        setLoading(false);
      });
  }

  return (
    <Container fluid className="p-0 order-to-provider">
      <Helmet>
        <title>{renderTitle()}</title>
      </Helmet>
      <HeaderPage title={renderTitle()}>
        <>
          {!isNew && (
            <>
              <div className="order-to-provider__date-block">
                <Label>Дата</Label>
                <ButtonGroup>
                  <InputMask
                    id="createdAt"
                    name="createdAt"
                    type="text"
                    onChange={() => { }}
                    value={createdAt}
                    mask={"99.99.9999"}
                    className="form-control date"
                    disabled
                  />
                </ButtonGroup>
              </div>
            </>
          )}
        </>
      </HeaderPage>

      {loading && <MySpinner overlay />}

      <Card className="order-to-provider__form mb-0">
        <CardBody className="pb-3">
          <Row>
            <Col md="6" className="elem-field">
              <Label className="text-sm-right">Поставщик</Label>
              <Select
                name="provider"
                placeholder="Выберите поставщика"
                className="react-select-container"
                classNamePrefix="react-select"
                options={suggestions}
                isSearchable
                isLoading={searchLoading}
                inputValue={search}
                onInputChange={setSearch}
                value={provider}
                onChange={setProvider}
              />
            </Col>
            <Col md="3" className="elem-field">
              <Label className="text-sm-right">Тип заказа</Label>
              <Select
                name="type"
                placeholder="Тип заказа"
                className="react-select-container"
                classNamePrefix="react-select"
                options={TYPES}
                value={TYPES.find((v) => type === v.value)}
                defaultValue={TYPES.find((v) => "express" === v.value)}
                onChange={(val) => setType(val.value)}
              />
            </Col>
          </Row>
          <Row>
            <Col md="3" className="elem-field">
              <Label className="text-sm-right">Номер документа</Label>
              <Input
                name="docNum"
                placeholder="Номер документа"
                value={docNum}
                onChange={(e) => setDocNum(e.target.value)}
                invalid={needValid && errors.hasOwnProperty("docNum")}
              />
            </Col>
            <Col md="3" className="elem-field">
              <Label className="text-sm-right">Дата документа</Label>
              <DatePicker
                placeholderText="Дата документа"
                selected={date}
                onChange={dateValidate}
                selectsStart
                dateFormat="dd.MM.yyyy"
                locale="ru"
                className={classNames("form-control", {
                  error: needValid && errors.hasOwnProperty("date"),
                })}
              />
            </Col>
            <Col md="4">
              <Label className="text-sm-right">Документ</Label>
              <div>
                <Button onClick={importDocumentHandler}>
                  Загрузить документ
                </Button>
                {docLink && (
                  <a
                    href={`${process.env.REACT_APP_BASE_URL}${docLink}`}
                    className="ml-2"
                  >
                    Скачать
                  </a>
                )}
                <Input
                  type="file"
                  id="document"
                  hidden
                  innerRef={inputDocumentFile}
                  onChange={(e) => setDocumentFile(e.target.files[0])}
                />
              </div>
            </Col>
            <Col md="4">
              <Label className="text-sm-right">Дата поставки</Label>
              <DatePicker
                placeholderText="Дата поставки"
                selected={dateArrival}
                onChange={dateArrivalValidate}
                selectsStart
                dateFormat="dd.MM.yyyy"
                locale="ru"
                className={classNames("form-control", {
                  error: needValid && errors.hasOwnProperty("date"),
                })}
              />
            </Col>
          </Row>
          <Row>
            <Col>
              <Label className="text-sm-right">Комментарий</Label>
              <Input
                type="textarea"
                name="comment"
                placeholder="Комментарий"
                value={comment}
                onChange={(e) => setComment(e.target.value)}
              />
            </Col>
          </Row>
          {!isNew && (
            <Row>
              <Col md="3">
                <Label className="text-sm-right">Автор</Label>
                <Input value={admin.name} disabled />
              </Col>
            </Row>
          )}

          <Row>
            <Col md="3">
              <StatusOrderToProvider
                status={status}
                statuses={statuses}
                statusHandler={statusHandler}
              >
                {status.name}
              </StatusOrderToProvider>
            </Col>
          </Row>
        </CardBody>
      </Card>

      {!isNew && (
        <Card className="order-to-provider__button-save mb-0">
          <CardBody className="pt-1">
            <Button
              color="primary"
              onClick={updateHandler}
              className="button-wide"
            >
              Сохранить
            </Button>
          </CardBody>
        </Card>
      )}

      <Card className="order-to-provider-product mb-0">
        <CardBody>
          {loading && <MySpinner overlay />}

          <Row className="order-to-provider-product__toolbar">
            <Col md="12" className="button-block">
              <Button
                color="primary"
                onClick={() => setOpenModal(true)}
                className="button-wide mr-2"
              >
                Добавить товар
              </Button>

              <>
                <Button onClick={importHandler} className="mr-2">Импорт</Button>
                <Input
                  type="file"
                  id="orderToProvider"
                  hidden
                  innerRef={inputFile}
                  onChange={(e) => setFile(e.target.files[0])}
                />

                <a
                  href="https://api.lider-truck.ru/files/templates/orderToProviderTemplate.xlsx"
                  className="btn btn-secondary button-wide mr-2"
                >
                  Скачать шаблон
                  <CornerRightDownIcon size={15} />
                </a>
                {!isNew && (
                  <Button onClick={exportHandler} className="mr-2">Выгрузить в Excel</Button>
                )}
              </>
            </Col>
          </Row>
        </CardBody>
      </Card>

      {isNew && (
        <Card className="order-to-provider__button-save mb-0">
          <CardBody className="pt-1">
            <Form className="mb-3">
              <Row>
                <Col md={1}>
                  <Label>Запас (мес)</Label>
                  <Select
                    name="stockMonths"
                    placeholder="Запас"
                    className="react-select-container"
                    classNamePrefix="react-select"
                    options={STOCK_MONTHS}
                    value={STOCK_MONTHS.find(v => v.value === stockMonths)}
                    onChange={(val) => {
                      setStockMonths(val);
                    }}
                  />
                </Col>
                <Col md={2}>
                  <Label>ABC</Label>
                  <Select
                    isMulti
                    name="abc"
                    placeholder="ABC"
                    className="react-select-container"
                    classNamePrefix="react-select"
                    options={ABC}
                    value={ABC.map((val) => {
                      for (let f of filterAbc) {
                        if (f.value === val.value) {
                          return val;
                        }
                      }
                      return false;
                    })}
                    onChange={(val) => {
                      setFilterAbc(val);
                    }}
                  />
                </Col>
                <Col md={2}>
                  <Label>Статус</Label>
                  <Select
                    isMulti
                    name="status"
                    placeholder="Статус"
                    className="react-select-container"
                    classNamePrefix="react-select"
                    options={ABC.filter(v => v.value === 1 || v.value === 4)}
                    value={ABC.map((val) => {
                      for (let f of filterStatus) {
                        if (f.value === val.value) {
                          return val;
                        }
                      }
                      return false;
                    })}
                    onChange={(val) => {
                      setFilterStatus(val);
                    }}
                  />
                </Col>
                <Col md={3}>
                  <Label>Бренд</Label>
                  <SelectSearch
                    name="brand"
                    placeholder="Выберите бренд"
                    functionSuggestion={brandsSuggestion}
                    value={brand}
                    setValue={setBrand}
                    isClearable
                  />
                </Col>
                <Col>
                  <Button
                    color="primary"
                    onClick={selectHandler}
                    className="button-wide with-label"
                  >
                    Подобрать
                  </Button>
                </Col>
              </Row>

              <Row>
                <Col md="3">
                  <Label className="text-sm-right">Поставщик</Label>
                  <Select
                    isClearable
                    name="provider"
                    placeholder="Поставщик"
                    className="react-select-container"
                    classNamePrefix="react-select"
                    options={providers}
                    value={provider}
                    onChange={setProvider}
                  />
                </Col>
                <Col>
                  <Button
                    color="primary"
                    onClick={filterHandler}
                    className="button-wide with-label mr-3"
                  >
                    Фильтр
                  </Button>
                  <Button
                    color="primary"
                    onClick={searchHandler}
                    className="button-wide with-label"
                  >
                    Проценить
                  </Button>
                </Col>
              </Row>
              {
                products?.length > 0 && (
                  <Row>
                    <Col>
                      {isNew && (
                        <Button
                          color="primary"
                          onClick={createHandler}
                          className="button-wide mt-2"
                        >
                          Создать заказ поставщику
                        </Button>
                      )}
                    </Col>
                  </Row>
                )
              }
            </Form>
          </CardBody>
        </Card>
      )}

      {isNew ? (
        <OrdersToProviderProductTableNew
          products={filteredProducts}
          setProducts={setProducts}
          setSelected={setSelected}
          selected={selected}
          setPrice={setPrice}
        />
      ) : (
        <OrdersToProviderProductTable
          id={id}
          products={products}
          setProducts={setProducts}
          isNew={isNew}
          provider={provider}
          getAndSetOrderToProvider={getAndSetOrderToProvider}
        />
      )}

      <AddProductModal
        orderToProviderId={id}
        openModal={openModal}
        setOpenModal={setOpenModal}
        setProducts={setProducts}
        setLoading={setLoading}
        provider={provider}
      />


    </Container >
  );
};
